var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[(_vm.article)?_c('article-view',{attrs:{"previous-route":{name: 'support'},"title":_vm.article.title,"description":_vm.article.description,"body":_vm.article.body,"links":_vm.links}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }